<div class="overlay-backdrop" *ngIf="isEditorVisible">
  <div class="overlay-content" (click)="$event.stopPropagation()">
    <div class="new-footer-header">
      <div class="title">{{ 'Workflow Settings' }}</div>
      <button class="modal-close" (click)="close()">✕</button>
    </div>
    <!-- <ng-container *ngIf="!isLoading; else loadingTemplate"> -->
    <div class="modal-body">
      <div class="view-workflow-main-container">
        <div class="workflow-details-container">
          <div class="workflow-details">
            <div class="workflow-name">
              <wm-common-text
                [data]="{
                  text: workflow?.version?.name
                }"
              ></wm-common-text>
            </div>
            <div class="{padding: 0px}">
              <wm-common-text
                [data]="{
                  text: workflow?.version?.description
                }"
              ></wm-common-text>
            </div>
            <div class="workflow-buttons">
              <div>
                <!-- BUILDER BUTTON -->
                <wm-workflow-janus-actions
                  [row]="workflow"
                  [isEntitledToDisable]="permissions?.disable"
                  [isEntitledToPublish]="permissions?.publish"
                  [isEntitledToHistory]="permissions?.history"
                  [isEntitledToBuilder]="permissions?.builder"
                  [isEntitledToStart]="permissions?.start"
                  [isEntitledToArchive]="permissions?.archive"
                  (action)="onAction($event)"
                ></wm-workflow-janus-actions>
                <!-- BUILDER BUTTON -->
              </div>
              <!-- SETTINGS BUTTON -->
              <button
                mat-raised-button
                color="primary"
                class="settings-button"
                type="button"
                (click)="settingsButtonClick()"
              >
                <div style="display: flex; flex-direction: row; row-gap: 0px;">
                  <!-- [routerLink]="['/admin/workflow-builder', row.id]" -->
                  <span class="settings-button-text">
                    SETTINGS
                  </span>

                  <ng-template #archivedText>
                    <span class="settings-disable-button-text">
                      SETTINGS
                    </span>
                  </ng-template>

                  <span
                    class="settings-button-icon"
                    [matMenuTriggerFor]="menu"
                    (click)="$event.stopPropagation()"
                  >
                    <mat-icon>expand_more</mat-icon>
                  </span>
                </div>
              </button>
              <!-- SETTINGS BUTTON -->
            </div>
          </div>
          <div class="workflow-details-card">
            <div class="workflow-details-layout">
              <div class="workflow-details-headers">
                @for (row of workflowDetailsColumns; track row) {
                <div class="workflow-details-column-layout">
                  <!-- <div class="bold-headers"> -->
                  <wm-common-text
                    [data]="{
                      text: row.name,
                      fontWeight: '500',
                      fontSize: '16px'
                    }"
                  ></wm-common-text>
                  <!-- </div> -->
                  <!-- <div> -->
                  <wm-common-text
                    [data]="{
                      text: row.value || 'N/A'
                    }"
                  ></wm-common-text>
                  <!-- </div> -->
                </div>
                }
              </div>
              <div class="workflow-details-headers">
                <div class="last-published-layout">
                  <!-- <div class="bold-headers"> -->
                  <wm-common-text
                    [data]="{
                      text: 'Last Published On',
                      fontWeight: '500',
                      fontSize: '16px'
                    }"
                  ></wm-common-text>
                  <!-- </div> -->
                  <!-- <div> -->
                  <wm-common-text
                    [data]="{
                      text: workflow?.lastPublishedOn
                        ? (workflow.lastPublishedOn | date: 'MM/dd/y, hh:mm a')
                        : 'Never published'
                    }"
                  ></wm-common-text>
                  <!-- </div> -->
                </div>
                <div class="publish-history">
                  <wm-common-button
                    [data]="{
                      text: 'PUBLISH HISTORY'
                    }"
                    (click)="openPublishHistoryConfirmationModal()"
                  ></wm-common-button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <app-common-filterbuilder-staff-janus
            [placeholder]="'Search applications'"
            (search)="onSearch($event)"
            (attributeSelect)="onAttribute($event)"
            (bulkSelect)="onBulk($event)"
            [attributeOptions]="filterCriteria"
            [myWorkOptions]="myWorkOptions"
            (filterChanged)="onFilterChanged($event)"
            [useMuiLayout]="true"
            [externalFilterInputs]="filterInputs"
            (externalFilterInputsChange)="onExternalFiltersChanged($event)"
            [customTemplate]="BulkButtonTemplate"
          >
          </app-common-filterbuilder-staff-janus>
          <ng-template #BulkButtonTemplate>
            <div class="bulk-actions-container" *ngIf="bulkActions?.length">
              <!-- BULK BUTTON -->
              <div
                class="blue-btn clickable"
                [class.disabled]="selectedIds.size === 0"
                [matMenuTriggerFor]="bulkMenu"
              >
                <mat-icon>content_copy</mat-icon>
                <span>BULK</span>
                <mat-icon class="arrow">keyboard_arrow_down</mat-icon>
              </div>

              <!-- BULK MENU -->
              <mat-menu #bulkMenu="matMenu" yPosition="below" xPosition="after">
                <button
                  mat-menu-item
                  *ngFor="let action of bulkActions"
                  (click)="onBulkActionClick(action)"
                  [disabled]="selectedIds.size === 0"
                >
                  {{ action.name }}
                </button>
              </mat-menu>
            </div>
          </ng-template>
        </div>
        <div class="tab-spacing">
          <mat-tab-group
            class="main-tab"
            mat-stretch-tabs="false"
            mat-align-tabs="start"
            mat-dynamic-height="true"
            animationDuration="10ms"
            [selectedIndex]="selectedIndex"
            (selectedIndexChange)="onTabChange($event)"
          >
            @for(tab of tabsList; track tab) {
            <mat-tab class="tab-label" [label]="formatTabLabel(tab)"></mat-tab>
            }
          </mat-tab-group>

          <div class="tab-content">
            <ng-container *ngIf="!isLoading; else loadingTemplate">
              <ng-container *ngIf="activeMainTab === 'data'">
                <wm-common-table
                  tableType="Staff"
                  [columns]="columns"
                  [data]="applications"
                  [serverSidePagination]="true"
                  [totalPages]="page.totalPages"
                  [currentPage]="page.pageNumber"
                  [pageSize]="page.size"
                  [showRowsPerPage]="true"
                  [showTotalRecords]="true"
                  [totalRecords]="page.totalElements"
                  [pageSizeStorageKey]="'workflow-applications-janus'"
                  (rowsPerPageChange)="onRowsPerPageChange($event)"
                  (pageChange)="onPageChange($event)"
                  (sortChanged)="onSortChanged($event)"
                  [sortField]="sortField"
                  [sortDescending]="sortDescending"
                  (checkboxSelect)="onRowToggle($event)"
                  (headerCheckboxClick)="onHeaderToggle($event)"
                  tableHeight="500px"
                ></wm-common-table>
              </ng-container>
              <ng-container *ngIf="activeMainTab == 'map'">
                <app-basic-esri-map
                  [inputFilters]="mapFilters$"
                  [initialFilters]="[]"
                  [popupTemplateTitle]="'App #: {applicationNumber}'"
                  [popupTemplateContent]="
                    'Type: {permitType}&lt;br>Description: {description}&lt;br>Applicant: {applicantsName}&lt;br>Created: {dateCreated}&lt;br>Status: {status}&lt;br>'
                  "
                  [popupActions]="mapPopupActions"
                  (mapDataRequested)="onMapDataRequested($event)"
                >
                </app-basic-esri-map>
              </ng-container>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
    <!-- </ng-container> -->
  </div>
</div>

<ng-template #loadingTemplate>
  <div class="loader">
    <mat-progress-spinner mode="indeterminate" diameter="48">
    </mat-progress-spinner>
    <wm-common-text
      [data]="{ text: 'Retrieving data, please wait…' }"
    ></wm-common-text>
  </div>
</ng-template>

<mat-menu #menu="matMenu" xPosition="before" panelClass="menu-container">
  <button mat-menu-item (click)="openStartAppLinkConfirmationModal()">
    Start Application URL
  </button>
  <button mat-menu-item (click)="openStartAppParcelConfirmationModal()">
    Start Application URL with Parcel ID
  </button>
  <!-- <button mat-menu-item  *ngIf="!row.isArchived && row.isEnabled" (click)="emit('disable')">Start Application URL with Parcel ID</button> -->
</mat-menu>

<div class="modal-width">
  <wm-common-confirmation-modal
    [data]="startApplicationUrlModal"
    (onCloseClick)="startApplicationUrlModal.open = false"
    [isApplicantMobileview]="true"
  >
    <div class="workflow-details-column-layout">
      <wm-common-text
        [data]="{
          text: 'Copy the text below and place it in the website of your choice to start an application for this workflow.',
        }"
      ></wm-common-text>

      <code>
        {{ startAppLink }}
      </code>
    </div>
  </wm-common-confirmation-modal>
</div>

<div class="modal-width">
  <wm-common-confirmation-modal
    [data]="startApplicationParcelModal"
    (onCloseClick)="startApplicationParcelModal.open = false"
    [isApplicantMobileview]="true"
  >
    <div class="workflow-details-column-layout">
      <wm-common-text
        [data]="{
          text: 'Copy the text below and place it in the website of your choice to start an application for this workflow.',
        }"
      ></wm-common-text>
      <wm-common-text
        [data]="{
          text: 'Replace the {ParcelId} text with the actual Parcel Number in the URL.',
        }"
      ></wm-common-text>
      <code>
        {{ startAppLinkWithParcelId }}
      </code>
    </div>
  </wm-common-confirmation-modal>
</div>

<div class="modal-width">
  <wm-common-confirmation-modal
    [data]="publishHistoryConfirmModal"
    (onCloseClick)="publishHistoryConfirmModal.open = false"
    [isApplicantMobileview]="true"
  >
    <div class="publish-history-table-wrapper">
      <wm-common-table
        [columns]="publishHistoryColumns"
        [data]="publishRows"
        [serverSidePagination]="false"
      ></wm-common-table>
    </div>
  </wm-common-confirmation-modal>
</div>

<wm-modal-confirm
  [showButton]="false"
  moduleId="currentActivitiesConfirmJanus"
  [title]="bulkActionText + ' ' + selected?.length + ' Application(s)'"
  [commandText]="bulkActionText + ' ' + selected?.length + ' Application(s)'"
  (accepted)="bulkCloseApplications(selected)"
  [janusStyling]="true"
  (canceled)="resetBulkSelection()"
  janusModalWidth="600px"
  [enabled]="true"
  [form]="bulkActionForm"
  [closeOnAccept]="false"
  #bulkActionConfirm
>
  <div [formGroup]="bulkActionForm">
    <div class="row">
      <div class="col">
        <label for="bulkActionReason">{{ bulkActionText }} Reason</label>
        <!-- <textarea
          style="height:100px"
          id="bulkActionReason"
          name="bulkActionReason"
          class="form-control mx-2"
          formControlName="bulkActionReason"
          [placeholder]="bulkActionText + ' Reason'"
          [attr.aria-label]="bulkActionText + ' Reason'"
        >
        </textarea> -->
        <wm-common-textfield
          class="mx-2"
          formControlName="bulkActionReason"
          [data]="{
            type: 'text-area',
            id: 'bulkActionReason',
            label: bulkActionText + ' Reason',
            textAreaRows: 4,
            required: true
          }"
        >
        </wm-common-textfield>
        <div *ngIf="bulkActionReason?.untouched" class="text-danger">
          * {{ bulkActionText }} Reason is required.
        </div>
        <div
          *ngIf="
            bulkActionReason?.invalid &&
            (bulkActionReason?.dirty || bulkActionReason?.touched)
          "
          class="alert alert-danger"
        >
          <div *ngIf="bulkActionReason.errors['required']" class="text-danger">
            * {{ bulkActionText }} Reason is required. *
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <label for="bulkActionDateTime" class="mt-2">
          Time
          <input
            id="bulkActionDateTime"
            name="bulkActionDateTime"
            class="form-control mt-2"
            formControlName="bulkActionDateTime"
            placeholder=""
            aria-label="DateTime"
          />
        </label>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <label class="mt-2">
          Changed By
          <input
            name="bulkActionUser"
            class="form-control mt-2"
            formControlName="bulkActionUser"
            placeholder=""
            aria-label="BulkActionUser"
          />
        </label>
      </div>
    </div>
  </div>

  <p>
    Any inspections currently in progress in these applications will be marked
    as Voided, and will not be visible by default in inspection searches.
  </p>

  <p>
    Are you sure you want to {{ bulkActionText.toLowerCase() }}
    <b>{{ selected?.length }} application(s)</b>?
  </p>
</wm-modal-confirm>
